var _a, _b;
import { generateActions } from "../generators/generator.actions";
import { EActionState, createCustomAction } from "../utils/action.utils";
import { GENERATOR_PARAMS } from "./bankAccount.constants";
export var getCountStart = (_a = generateActions(GENERATOR_PARAMS), _a.getCountStart), getCountSucceeded = _a.getCountSucceeded, getCountFailed = _a.getCountFailed, getDetailStart = _a.getDetailStart, getDetailSucceeded = _a.getDetailSucceeded, getDetailFailed = _a.getDetailFailed;
var EActionCustom;
(function (EActionCustom) {
    EActionCustom["RemoveBankAccount"] = "REMOVE_BANK_ACCOUNT";
})(EActionCustom || (EActionCustom = {}));
var generateRemoveBankAccountActions = function () { return ({
    removeBankAccountStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.RemoveBankAccount,
        state: EActionState.Start,
    }),
    removeBankAccountSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.RemoveBankAccount,
        state: EActionState.Success,
    }),
    removeBankAccountFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.RemoveBankAccount,
        state: EActionState.Fail,
    }),
}); };
export var removeBankAccountStart = (_b = generateRemoveBankAccountActions(), _b.removeBankAccountStart), removeBankAccountSucceeded = _b.removeBankAccountSucceeded, removeBankAccountFailed = _b.removeBankAccountFailed;
